<nav>

    <div class="main" style="padding-bottom:0;">

        <div class="flex_row">

            <div class="w30">
                <img src="assets/images/logo-nis.png">

                <hr class="header_line">

                <span>e-Visa</span>
            </div>

            <div class=" w70 menu">
                <ul class="nav-links">
                    <li><a routerLink="/dashboard">Dashboard</a></li>

                    <li><a href="javascript:void(0);" (click)="openSearchModel()">Find Application</a></li>

                    <li class="dropdown">
                        <a href="javascript:void(0);" class="custom_btn1">Hi, {{loggedUserFullName}} <i
                                aria-hidden="true" class="fa fa-caret-down"></i></a>

                        <ul class="dropdown-menu-top">
                            <li><a href="javascript:void(0);" (click)="doLogout()">Logout</a></li>
                        </ul>
                    </li>
                </ul>

            </div>

        </div>

    </div>


</nav>